export const DRIVER_BLOCKED_BY_FLEET_OWNER_REASON = "driver_deactivation_by_fleet_owner";
